<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="h-screen bg-white flex flex-col items-center overflow-hidden z-poll papsi-poll pb-4"
  >
    <div
      class="bg-primary w-full flex flex-col items-center flex-shrink-0"
      style="height: 105px"
    >
      <div class="flex items-center w-full mt-4 px-3">
        <img
          src="@/assets/icons/papsi_arrow_back_alt.svg"
          alt="Back"
          class="w-5 h-5 cursor-pointer"
        />

        <div class="flex-1 flex justify-center">
          <img :src="getLogoPath()" class="w-24" />
        </div>

        <div class="w-5"></div>
      </div>

      <div class="flex justify-center mt-4">
        <div
          v-for="n in 3"
          :key="n"
          class="w-8 h-8 flex items-center justify-center rounded-full text-white font-bold"
          :class="[
            index === n ? 'bg-secondary-dark' : '',
            n !== 3 ? 'mr-3' : '',
          ]"
          :style="index === n ? '' : 'background-color: rgba(255,255,255,0.2)'"
        >
          {{ n }}
        </div>
      </div>
    </div>
    <div
      v-if="index === 1"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000255")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="personal_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000145')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000146')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.suffix"
            name="suffix"
            :placeholder="lang('lbl_0000385')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000325')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000386") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="id_type"
            :placeholder="lang('lbl_0000387')"
            :options="getGenders"
            v-model="id_info.id_type"
            :full_width="false"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.id_number"
            name="id_number"
            :placeholder="lang('lbl_0000388')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            type="date"
            v-model="id_info.id_expiry"
            name="id_expiry"
            :placeholder="lang('lbl_0000389')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.tin"
            name="tin"
            :placeholder="lang('lbl_0000098')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            type="date"
            :birthday="true"
            v-model="id_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000105')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.place_of_birth"
            name="place_of_birth"
            :placeholder="lang('lbl_0000390')"
            required
            uppercase
            :full_width="false"
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000391')"
            name="nationality"
            :options="getGenders"
            v-model="id_info.nationality"
            :full_width="false"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            required
            uppercase
            :full_width="false"
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000401") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="present_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
            :full_width="false"
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="present_address.municipality"
            :full_width="false"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="present_address.province"
            :full_width="false"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="getGenders"
            v-model="present_address.country"
            :full_width="false"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :full_width="false"
            :numeric="true"
          />
        </div>
      </div>
      <div class="mt-4">
        <!-- Header with checkbox -->
        <div class="flex items-center justify-between">
          <span class="font-bold text-primary text-left">
            {{ this.lang("lbl_0000402") }}
          </span>

          <label
            class="flex items-center gap-2 text-sm text-gray-600 cursor-pointer"
          >
            <input
              type="checkbox"
              v-model="same_as_present"
              class="cursor-pointer mr-2"
            />
            <span>Same as above</span>
          </label>
        </div>

        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="permanent_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
            :full_width="false"
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
            :full_width="false"
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
            :full_width="false"
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="permanent_address.municipality"
            :full_width="false"
            required
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="permanent_address.province"
            :full_width="false"
            required
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="getGenders"
            v-model="permanent_address.country"
            :full_width="false"
            required
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
            :full_width="false"
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :full_width="false"
            :numeric="true"
            :disabled="same_as_present"
          />
        </div>
      </div>
      <div class="flex flex-row">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="this.$router.push('/dashboard')"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 2">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 2"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
    <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000401") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="present_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
            :full_width="false"
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="present_address.municipality"
            :full_width="false"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="present_address.province"
            :full_width="false"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="getGenders"
            v-model="present_address.country"
            :full_width="false"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
            :full_width="false"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :full_width="false"
            :numeric="true"
          />
        </div>
      </div>
      <div class="flex flex-row">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="index = 1"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 3">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 3"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
    <div class="flex flex-row">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="index = 2"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="submit()">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
  </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import FormTextControl from "@/components/controls/FormTextControl.vue";
import ComboboxControl from "@/components/controls/ComboboxControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ComboboxControl,
    FormTextControl,
    ButtonControl,
  },
  watch: {
    same_as_present(val) {
      if (val) {
        this.permanent_address = { ...this.present_address };
      }
    },
  },
  data() {
    return {
      index: 1,
      personal_info: {
        fname: "",
        mname: "",
        lname: "",
        suffix: "",
      },
      id_info: {
        id_type: "",
        id_number: "",
        id_expiry: "",
        tin: "",
        date_of_birth: "",
        place_of_birth: "",
        nationality: "",
        others: "",
      },
      present_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
      permanent_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
    };
  },
  mounted() {
    // this.$emit('checkauth');
    this.$emit("nofooter", true);
  },
  computed: {
    getGenders() {
      return [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
        { label: "Rather not say", value: "X" },
      ];
    },
  },
  methods: {
    getLogoPath() {
      const path = "ga/";
      const file_name = "papsi_logo.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    submit(){
      return;
    }
  },
};
</script>

<style scoped>
.bg-white-20 {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
